import { easeExp, easeExpOut, easeCubicIn } from 'd3-ease';
import { constrain, mapRange } from '.';

export function exponentialProgressEasing(value) {
  return mapRange(constrain(easeExp(value), 0.0005, 0.7545), [0.0005, 0.7545], [0, 1]);
}

export function exponentialOutProgressEasing(value) {
  return mapRange(easeExpOut(value), [0, 0.999023], [0, 1]);
}

export function easeCubicInProgress(value) {
  return constrain(mapRange(easeCubicIn(value), [0.0, 0.9], [0, 1]), 0, 1);
}
